import React from 'react'

// import DataPicker from '../../components/DatePicker1/DatePicker'
import withStyles from 'isomorphic-style-loader/lib/withStyles';
// @ts-ignore
import s from './DevTest.css'
class DevTest extends React.Component {
  constructor (props) {
    super(props)

    this.state ={
      startDate: new Date()
    }

    this.handleChange = this.handleChange.bind(this)
  }

  handleChange (date) {
    this.setState({
      startDate: date
    });    
  }

  render () {
    return (
      <div style={{
        padding: '100px'
      }}>

        {/* <DataPicker /> */}

      </div>
    )
  }
}

export default withStyles(s)(DevTest);



// WEBPACK FOOTER //
// src/routes/devTest/DevTest.js